// 0xGG Team
// Distributed under AGPL3
//
// DESCRIPTION: This widget tries to build a widget using react
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "react", "react-dom"], function (require, exports, react_1, react_dom_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HelloWidget = void 0;
    react_1 = __importStar(react_1);
    react_dom_1 = __importDefault(react_dom_1);
    function Hello(props) {
        var _a = react_1.useState(props.attributes.value || ""), value = _a[0], setValue = _a[1];
        return (react_1.default.createElement("div", { style: {
                cursor: "default",
                padding: "24px",
                boxShadow: "0 1px 6px 2px #ddd",
            } },
            react_1.default.createElement("span", null,
                "Hello, world! I am ",
                react_1.default.createElement("b", null, value || "EchoMD")),
            react_1.default.createElement("br", null),
            react_1.default.createElement("input", { style: { zIndex: 9999 }, placeholder: "Enter your name here", value: value }),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                react_1.default.createElement("button", { style: { marginTop: "4px", marginRight: "4px" }, onClick: function () {
                        if (props.setAttributes)
                            props.setAttributes(__assign(__assign({}, props.attributes), { value: value }));
                    } }, "Save"),
                react_1.default.createElement("button", { style: { marginTop: "4px", marginRight: "4px" }, onClick: function () {
                        if (props.removeSelf) {
                            props.removeSelf();
                        }
                    } }, "Delete"),
                react_1.default.createElement("button", { style: { marginTop: "4px", marginRight: "4px" }, onClick: function () {
                        if (props.replaceSelf) {
                            props.replaceSelf("**" + value + "** is awesome ;)");
                        }
                    } }, "Replace"))));
    }
    var HelloWidget = function (args) {
        var el = document.createElement("span");
        react_dom_1.default.render(react_1.default.createElement(Hello, __assign({}, args)), el);
        return el;
    };
    exports.HelloWidget = HelloWidget;
});
